<template>
  <div>
    <div class="badge badge-info">{{ poolPackage.name }}</div>
    <div class="small mb-2">
      <strong>Érvényesség:</strong><div>{{ validityStart }}&mdash;{{ validityEnd }}</div>
    </div>
    <state-overview class="small" :state="poolState"/>
  </div>
</template>
<script>
import moment from 'moment'
import StateOverview from './StateOverview'
import poolState from '../_poolState'

export default {
  components: {
    'state-overview': StateOverview
  },
  props: {
    pool: {
      required: true,
      type: Object,
      default: () => ({
        'validity_start': '',
        'validity_end': '',
      })
    },
    poolPackage: {
      required: true,
      type: Object,
      default: () => ({
        'name': '',
        'limitations': []
      })
    },
    poolState: {
      required: true,
      type: Object,
      default: () => (poolState)
    }
  },
  computed: {
    validityEnd() {
      return moment(this.pool.validity_end, moment.ISO_8601).format(moment.HTML5_FMT.DATE)
    },
    validityStart() {
      return moment(this.pool.validity_start, moment.ISO_8601).format(moment.HTML5_FMT.DATE)
    }
  },
}
</script>